import Footer from '../../Components/Footer/Footer'
import Logo from '../../Components/Logo/Logo'
import { ActivationScreenEvents, BrandName } from '../../Typescript'
import { useEffect } from 'react'
import './AuthComplete.css'
import AppMeasurements from '../../Services/AppMeasurements'

function AuthComplete({ brandName }: { brandName: BrandName }) {
    useEffect(() => {
        AppMeasurements.start(ActivationScreenEvents.confirmationScreen)
    }, [])
    return (
        <div className="container">
            <Logo brandName={brandName} />
            <div>
                <h2 className="main-header">Your Device is ready to use</h2>
                <h3 className="instructions">You now have access to your favorite shows</h3>
            </div>
            <Footer brandName={brandName} />
        </div>
    )
}

export default AuthComplete
